import { NgModule } from '@angular/core';
import { SharedModule } from '../../../../common/modules/shared';

// import { BookingListComponent } from './booking-list/BookingListComponent';
// import { BookingDetailComponent } from './booking-detail/BookingDetailComponent';

import { parentProfileRouting } from './ParentProfileRouting';
import { AddParentComponent } from './add-parent/AddParentComponent'
import { GrowlModule } from 'primeng/primeng';
// import { BookingService } from '../../services';
@NgModule({
    imports: [
        SharedModule,
        parentProfileRouting,
        GrowlModule
    ],
    declarations: [
        AddParentComponent,
    ],
    providers: [
    //    BookingService
    ],
})

export class ParentProfileModule { }


// WEBPACK FOOTER //
// ./src/holiday/parent/profile/parent/ParentProfileModule.ts